import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { FormData } from '../Utils/form-data';
import { OpenEndFunds } from '../Utils/formdata.models';
import { DynamoService } from '../utils/dynamo.service';
import { Router } from '@angular/router';

@Component({
  // tslint:disable-next-line: quotemark
  selector: "app-open-end-funds",
  templateUrl: './open-end-funds.component.html',
  styleUrls: ['./open-end-funds.component.css']
})
export class OpenEndFundsComponent implements OnInit {
  dataPosted = false;
  instruments;
  trackRecord;
  formOpenEnd: FormGroup;
  isDataAvailable = false;
  recaptcha: boolean;
  inputTypeNumbers = [true, true, true, true, true];
  nrSelect1:string = 'trackRecord';


  constructor(public formData: FormData, private dynamo: DynamoService, private router: Router) { }

  ngOnInit() {
    if (this.formData.investmentStrategyMain.isDataValid()) {
      this.dynamo.getLookupName('L__SatoriPrimeStrat').subscribe(data => {
        this.instruments = data;
        this.isDataAvailable = true;
      }, error => {
        console.log('Lookup error: ', error);
      });

      this.dynamo.getLookupName('L__SatoriTrackRecord').subscribe(data => {
        this.trackRecord = data;
      }, error => {
        console.log('Lookup error: ', error);
      });

      this.formData.openEndFunds = new OpenEndFunds();
      this.formOpenEnd = this.formData.openEndFunds.getFormGroup();
    } else {
      this.router.navigate(['investment-strategy-main']);
    }
  }
  public resolved(captchaResponse: string) {
    this.recaptcha = !!captchaResponse;
  }


  onCheckChange(event) {
    const formArray: FormArray = this.formOpenEnd.get(
      'primarilyTrade'
    ) as FormArray;

    if (event.target.checked) {
      formArray.push(new FormControl(event.target.value));
    } else {
      let i = 0;

      formArray.controls.forEach((ctrl: FormControl) => {
        if (ctrl.value === event.target.value) {
          formArray.removeAt(i);
          return;
        }

        i++;
      });
    }
  }

  handleNumbers(numberValue, placeofInput) {
    this.inputTypeNumbers[placeofInput] = !isNaN(numberValue);
    return this.inputTypeNumbers[placeofInput];
  }
  setProps() {
    if (!this.dataPosted) {
      this.dataPosted = true;
      this.formData.openEndFunds.migrateFormData();
      this.dynamo.postData(this.formData.constructWebFormPlaceholder(), 'WebFormPlaceholder')
        .subscribe(data => {
          this.router.navigate(['/thank-you']);
        }, error => {
          console.log('Post Data Error:', error);
        });
    }
  }
}

